/**
 * «Quanti pezzi di … stanno in una scatola?» (rule 47-ter, point 4).
 *
 * The figure is saved on the product, so next time it is already filled in and
 * can be corrected. Without it the proposal is not computed: the dialog asks
 * for it before drawing anything.
 */

import { useState } from 'react';

export interface CapacityFieldProps {
  readonly productId: number;
  readonly productName: string;
  /** The figure already saved, if any. */
  readonly initial: number | undefined;
  readonly busy: boolean;
  readonly onSave: (productId: number, pieces: number) => void;
}

/** 1–999 whole pieces, as the API accepts them. */
const valid = (n: number): boolean => Number.isInteger(n) && n >= 1 && n <= 999;

export function CapacityField({
  productId,
  productName,
  initial,
  busy,
  onSave,
}: CapacityFieldProps) {
  const [value, setValue] = useState(initial === undefined ? '' : String(initial));
  const id = `capienza-${productId}`;
  const pieces = Number(value);
  const ok = value.trim() !== '' && valid(pieces);

  return (
    <form
      className="posto__capienza"
      onSubmit={(e) => {
        e.preventDefault();
        if (ok && !busy) onSave(productId, pieces);
      }}
    >
      <label htmlFor={id} className="posto__capienza-k">
        Quanti pezzi di {productName} stanno in una scatola?
      </label>
      <input
        id={id}
        className="mod mod__quanti"
        type="number"
        inputMode="numeric"
        min={1}
        max={999}
        step={1}
        value={value}
        onChange={(e) => setValue(e.target.value)}
      />
      <button className="mod" type="submit" disabled={!ok || busy}>
        Salva
      </button>
    </form>
  );
}
